export interface SkuStock {
  [sku: string]: number | undefined;
}

export type ProductChannelStatus = "Estimation" | "Order";

export interface Item {
  number: string;
  size: string;
  variantCode: string;
  ean: string;
  eanPack?: string;
}

export interface OrderItemForExcel {
  categories: string;
  season?: string;
  articleName: string;
  articleId: string;
  sku: string;
  variantCode: string;
  ean: string;
  eanPack?: string;
  isCollab?: string;
  collectionSegment?: string;
  assortmentSegment?: string;
  size: string;
  price: string;
  packageSize: number;
  estimatedQty: string;
  ordered: string;
  liabilityMet: string;
  month: number;
  availableStock: string | StockNotKnown;
  stockOrder: number;
}

export interface ItemForExcel {
  articleName: string;
  categories: string;
  season?: string;
  articleId: string;
  variantCode: string;
  sku: string;
  ean: string;
  eanPack?: string;
  isCollab?: string;
  collectionSegment?: string;
  assortmentSegment?: string;
  size: string;
  price: string;
  packageSize: number;
  estimationMonth1: number;
  estimationMonth2: number;
  estimationMonth3: number;
}

export default interface Product {
  name: string;
  articleId: string;
  items: Item[];
  image: string;
  packageSize: number;
  discountCodeASet: boolean;
  wholesalePrice: number;
  retailPrice: number;
  season: string;
  isCollab?: string;
  collectionSegment?: string;
  assortmentSegment?: string;
  wbCheck: SkuStock;
  wbStock: SkuStock;
  isFreeToOrder: boolean;
}

export const getProduct = (products: Product[], articleId: string): Product =>
  products.find((product: Product) => product.articleId === articleId)!;

export const getSkuStock = (
  product: Product,
  sku: string
): number | undefined => product.wbStock[sku];

export const getSkuCheck = (
  product: Product,
  sku: string
): number | undefined => product.wbCheck[sku];

export const getProductCheckLevel = (
  products: Product[],
  articleId: string,
  sku: string
): number | undefined => {
  const product = products.find((a: Product) => a.articleId === articleId);
  return product ? product.wbCheck[sku] : undefined;
};

export const getProductStockLevel = (
  products: Product[],
  articleId: string,
  sku: string
): number | undefined => {
  const product = products.find((a: Product) => a.articleId === articleId);
  return product ? product.wbStock[sku] : undefined;
};

export const isEnabledFromStock = (
  isLiabilityMet: boolean,
  isFreeToOrder: boolean
): boolean => isFreeToOrder || isLiabilityMet;

type StockNotKnown = "?";

export const getStockValue = (
  product: Product,
  sku: string
): number | StockNotKnown => formatStock(getSkuStock(product, sku));

export const formatStock = (
  stockValue: number | undefined
): number | StockNotKnown => (stockValue !== undefined ? stockValue : "?");



// WEBPACK FOOTER //
// ./src/domain/Product.ts